// Interfaces
import { DataElement } from '../interfaces/PhysiologicalMonitoring';
import { ElementsDispatch } from '../interfaces/Reducers';

export const elementsReducer = (state: DataElement[], action: ElementsDispatch) => {
    if (action.type === 'ADD_TIMESTAMP') {
        return [{ date: action.date, comments: {}, values: {}, colors: {} }, ...state];
    }
    if (action.type === 'ADD_PHYSIOLOGICAL') {
        const { key, date, physiological, comment } = action;
        return state.map(el => {
            if (el.date !== date) return el;
            const newElement = { ...el };
            newElement.values[key] = physiological.value || null;
            newElement.values[key + '_db_id'] = physiological.id || null;
            newElement.values[key + '_user'] = physiological.user_id || null;
            newElement.comments[key + '_comment'] = comment || null;
            return newElement;
        });
    }
    if (action.type === 'UPDATE_PHYSIOLOGICAL') {
        const { key, date, value, comment, userID } = action;
        return state.map(el => {
            if (el.date !== date) return el;
            const newElement = { ...el };
            newElement.values[key] = isNaN(value) ? null : value;
            newElement.values[key + '_user'] = userID || null;
            newElement.comments[key + '_comment'] = comment || null;
            return newElement;
        });
    }
    if (action.type === 'DELETE_PHYSIOLOGICAL') {
        const { key, date } = action;
        return state.map(el => {
            if (el.date !== date) return el;
            const newElement = { ...el };
            delete newElement.values[key];
            delete newElement.values[key + '_db_id'];
            delete newElement.values[key + '_user'];
            delete newElement.comments[key + '_comment'];
            return newElement;
        });
    }
    if (action.type === 'SET_DEFAULT') {
        if (state[0]?.values && Object.keys(state[0].values).length === 0 && state[0]?.comments && Object.keys(state[0].comments).length === 0)
            return [state[0], ...action.payload]; // in case we have an empty column just added
        return action.payload;
    }
    return state;
};